/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bi_Dashboard_Settings_Section_TitleInputs */



/**
* | output |
* | --- |
* | "Dashboards" |
*
* @param {Bi_Dashboard_Settings_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bi_dashboard_settings_section_title = /** @type {((inputs?: Bi_Dashboard_Settings_Section_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bi_Dashboard_Settings_Section_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dashboards")
	return /** @type {LocalizedString} */ ("Dashboards")
});